import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './RoomCollection.css';
import axios from '../../utils/axiosInstance';

class RoomCard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentImageIndex: 0,
    };
  }

  handleNextImage = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const images = this.props.room?.images || [];

    if (images.length <= 1) return;

    this.setState((prevState) => ({
      currentImageIndex: (prevState.currentImageIndex + 1) % images.length,
    }));
  };

  handlePrevImage = (e) => {
    e.preventDefault();
    e.stopPropagation();

    const images = this.props.room?.images || [];

    if (images.length <= 1) return;

    this.setState((prevState) => ({
      currentImageIndex:
        prevState.currentImageIndex === 0
          ? images.length - 1
          : prevState.currentImageIndex - 1,
    }));
  };

  renderAmenity = (icon, value, label) => (
    <div className="room-collection-amenity" key={label}>
      <span className="room-collection-amenity-icon" aria-hidden="true">
        {icon}
      </span>
      <span className="room-collection-amenity-value">{value}</span>
      <span className="room-collection-amenity-label">{label}</span>
    </div>
  );

  render() {
    const { room } = this.props;
    const { currentImageIndex } = this.state;

    const fallbackImages = [
      'https://images.unsplash.com/photo-1582719508461-905c673771fd?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=85',
      'https://images.unsplash.com/photo-1540518614846-7eded433c457?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=85',
      'https://images.unsplash.com/photo-1584132967334-10e028bd69f7?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=85',
    ];

    const images = room?.images?.length ? room.images : fallbackImages;
    const safeImageIndex = currentImageIndex >= images.length ? 0 : currentImageIndex;
    const currentImage = images[safeImageIndex];

    return (
      <article className="card room-collection-card h-100">
        {/* Image */}
        <div className="room-collection-image-wrap position-relative">
          <Link
            to={`/listing/${room.id}`}
            className="room-collection-image-link"
            aria-label={`View ${room.title}`}
          >
            <img
              src={currentImage}
              className="room-collection-image"
              alt={`${room.title || 'Room'} - view ${safeImageIndex + 1}`}
            />
          </Link>

          <div className="room-collection-image-shade" aria-hidden="true" />

          {/* Location + Rating */}
          <div className="room-collection-image-info">
            <div className="room-collection-location-badge">
              <i className="bi bi-geo-alt-fill" aria-hidden="true" />
              <span>{room.location}</span>
            </div>

            <div className="room-collection-rating-badge">
              <i className="bi bi-star-fill" aria-hidden="true" />
              <span>{room.ratings || 'New'}</span>
            </div>
          </div>

          {/* Slider controls */}
          {images.length > 1 && (
            <>
              <button
                type="button"
                className="room-collection-slider-arrow room-collection-slider-prev"
                aria-label="Previous image"
                onClick={this.handlePrevImage}
              >
                <i className="bi bi-chevron-left" aria-hidden="true" />
              </button>

              <button
                type="button"
                className="room-collection-slider-arrow room-collection-slider-next"
                aria-label="Next image"
                onClick={this.handleNextImage}
              >
                <i className="bi bi-chevron-right" aria-hidden="true" />
              </button>

              <div className="room-collection-indicators" aria-hidden="true">
                {images.map((_, index) => (
                  <span
                    key={index}
                    className={`room-collection-indicator ${
                      index === safeImageIndex ? 'active' : ''
                    }`}
                  />
                ))}
              </div>
            </>
          )}
        </div>

        {/* Content */}
        <div className="room-collection-card-body">
          <Link to={`/listing/${room.id}`} className="room-collection-title-link">
            <h5 className="room-collection-title">{room.title}</h5>
          </Link>

          <div className="room-collection-amenities" aria-label="Room details">
            {this.renderAmenity(
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.9"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
                <circle cx="9" cy="7" r="4" />
                <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
                <path d="M16 3.13a4 4 0 0 1 0 7.75" />
              </svg>,
              room.guests,
              'Guests'
            )}

            {this.renderAmenity(
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.9"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M2 20v-8a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v8" />
                <path d="M4 10V6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v4" />
                <path d="M12 4v6" />
                <path d="M2 18h20" />
              </svg>,
              room.beds,
              'Beds'
            )}

            {this.renderAmenity(
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.9"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M10 4 8 6" />
                <path d="M17 19v2" />
                <path d="M2 12h20" />
                <path d="M7 19v2" />
                <path d="M9 5 7.62 3.62A2.12 2.12 0 0 0 4 5v12a2.12 2.12 0 0 0 2 2h12a2.12 2.12 0 0 0 2-2v-5" />
              </svg>,
              room.baths,
              'Baths'
            )}
          </div>
        </div>

        {/* Bottom price bar - left aligned */}
        <div className="room-collection-price-bar">
          <div className="room-collection-price-left">
            <span className="room-collection-currency">৳</span>
            <span className="room-collection-price">{room.price}</span>
            <span className="room-collection-price-night">/ night</span>
          </div>
        </div>
      </article>
    );
  }
}

class RoomCollection extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeFilter: 'All',
      rooms: [],
      loading: true,
    };

    this.filters = [
      'All',
      'Low Budgets',
      'New Arrivals',
      'Mirpur Stays',
      'Dhaka Stays',
      'Gulshan Stays',
      'Baridhara',
      'Premium stays',
      'Banani Stays',
      'Uttara Stays',
      'Party Stays',
      'Bashundhara Chills',
      'Chittagong Treasures',
      'Studio Rooms',
      'Mohammadpur',
    ];
  }

  componentDidMount() {
    this.fetchProperties('All');
  }

  getSearchTerm = (filter) => {
    if (filter === 'All' || filter === 'More...') return '';

    return filter
      .replace(/\s+(Stays|stays|Chills|Treasures|Rooms)$/i, '')
      .trim();
  };

  fetchProperties = async (filterTag) => {
  try {
    this.setState({ loading: true, rooms: [] });

    let endpoint = '/get_posts';
    const searchTerm = this.getSearchTerm(filterTag);

    if (searchTerm) {
      endpoint = `/get_posts?a=${encodeURIComponent(searchTerm)}`;
    }

    const response = await axios.get(endpoint);
    const propertiesData = response.data.data || response.data || [];

    const baseUrl = axios.defaults.baseURL
      ? axios.defaults.baseURL.replace('/api', '')
      : '';

    const mappedRooms = propertiesData.map((property) => {
      let galleryList = [];

      if (property.gallery_images) {
        try {
          const parsed =
            typeof property.gallery_images === 'string'
              ? JSON.parse(property.gallery_images)
              : property.gallery_images;
          galleryList = Array.isArray(parsed) ? parsed : [];
        } catch (error) {
          console.error('Error parsing gallery images:', error);
        }
      }

      // 1. Set feature_image first as default image
      const parsedGallery = [];
      if (property.feature_image) {
        parsedGallery.push(property.feature_image);
      }

      // 2. Append additional gallery images (preventing duplicate feature image)
      galleryList.forEach((img) => {
        if (img && !parsedGallery.includes(img)) {
          parsedGallery.push(img);
        }
      });

      const rawImages =
        parsedGallery.length > 0
          ? parsedGallery
          : [
              'https://images.unsplash.com/photo-1582719508461-905c673771fd?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=85',
              'https://images.unsplash.com/photo-1540518614846-7eded433c457?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=85',
              'https://images.unsplash.com/photo-1584132967334-10e028bd69f7?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=85',
            ];

      const formattedImages = rawImages
        .filter(Boolean)
        .map((img) =>
          typeof img === 'string' && img.startsWith('http')
            ? img
            : `${baseUrl}/uploads/posts/${img}`
        );

      return {
        id: property.id,
        images: formattedImages,
        location: property.category_name?.split(',')[0] || 'Unknown Location',
        ratings: property.ratings || 'New',
        title: property.title || 'Room',
        guests: property.adults || 0,
        beds: property.beds || 0,
        baths: property.baths || 0,
        sqft: property.size || 0,
        price: property.sales_price
          ? Number(property.sales_price).toLocaleString()
          : '0',
      };
    });

    this.setState({ rooms: mappedRooms });
  } catch (error) {
    console.error('Error fetching properties:', error);
    this.setState({ rooms: [] });
  } finally {
    this.setState({ loading: false });
  }
};

  handleFilterClick = (filter) => {
    this.setState({ activeFilter: filter });

    if (filter !== 'More...') {
      this.fetchProperties(filter);
    }
  };

  render() {
    const { activeFilter, rooms, loading } = this.state;

    return (
      <section className="room-collection-section py-5">
        <div className="container py-4 room-collection-container">
          <div className="text-center mb-4 room-collection-header">
            <h2 className="collection-title fw-bold">Explore Our Room Collection</h2>
          </div>

          <div className="room-collection-filters d-flex flex-wrap justify-content-center gap-2 gap-md-3 mb-5">
            {this.filters.map((filter, index) => (
              <button
                key={index}
                type="button"
                className={`btn room-collection-filter rounded-pill ${
                  activeFilter === filter ? 'active' : ''
                }`}
                onClick={() => this.handleFilterClick(filter)}
              >
                {filter}
              </button>
            ))}
          </div>

          {loading ? (
            <div className="room-collection-loading text-center py-5">
              <div className="spinner-border" role="status" aria-label="Loading rooms">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : rooms.length > 0 ? (
            <div className="row g-4 justify-content-center room-collection-grid">
              {rooms.map((room) => (
                <div className="col-12 col-md-6 col-lg-3" key={room.id}>
                  <RoomCard room={room} />
                </div>
              ))}
            </div>
          ) : (
            <div className="room-collection-empty text-center py-5">
              <i className="bi bi-house-door" aria-hidden="true" />
              <h4>No rooms found for “{activeFilter}”</h4>
              <p>Try selecting a different filter.</p>
            </div>
          )}

          <div className="text-center room-collection-view-all-wrap">
            <button
              type="button"
              className="btn room-collection-view-all rounded-pill px-5 py-2 shadow-sm fw-medium d-inline-flex align-items-center gap-2"
              onClick={() => this.handleFilterClick('All')}
            >
              <span>View All</span>
              <i className="bi bi-arrow-right" aria-hidden="true" />
            </button>
          </div>
        </div>
      </section>
    );
  }
}

export { RoomCard };
export default RoomCollection;
